import type { HubId } from 'types/navigation'
import Handshake from '@mui/icons-material/Handshake'
import ListAlt from '@mui/icons-material/ListAlt'
import AccountBalance from '@mui/icons-material/AccountBalance'
import LocalShipping from '@mui/icons-material/LocalShipping'
import Receipt from '@mui/icons-material/Receipt'
import AdminPanelSettings from '@mui/icons-material/AdminPanelSettings'
import Build from '@mui/icons-material/Build'
import type { SvgIconComponent } from '@mui/icons-material'

export interface HubDefinition {
  id: HubId
  title: string
  description: string
  Icon: SvgIconComponent
  /** Accent for hub icon / rail on dark chrome (hex). Keep light enough for cream text. */
  accent: string
}

export const HUB_ORDER: HubId[] = [
  'sales',
  'inventory',
  'financing',
  'operations',
  'backOffice',
  'admin',
  'tools',
]

export const HUBS: Record<HubId, HubDefinition> = {
  sales: {
    id: 'sales',
    title: 'Sales',
    description: 'Leads, submissions, and deals',
    Icon: Handshake,
    accent: '#7EC8E3',
  },
  inventory: {
    id: 'inventory',
    title: 'Inventory',
    description: 'Trucks, titles, photos, and lists',
    Icon: ListAlt,
    accent: '#A8B8D4',
  },
  financing: {
    id: 'financing',
    title: 'Financing',
    description: 'Applications and financing hub',
    Icon: AccountBalance,
    accent: '#8BC9A0',
  },
  operations: {
    id: 'operations',
    title: 'Operations',
    description: 'Transport, parts, locations, tasks',
    Icon: LocalShipping,
    accent: '#E8A06A',
  },
  backOffice: {
    id: 'backOffice',
    title: 'Back Office',
    description: 'Expenses, invoices, and time',
    Icon: Receipt,
    accent: '#C4A0E0',
  },
  admin: {
    id: 'admin',
    title: 'Admin',
    description: 'Users, audit, and staff admin',
    Icon: AdminPanelSettings,
    accent: '#F07178',
  },
  tools: {
    id: 'tools',
    title: 'Tools',
    description: 'Calculators, pricing, and utilities',
    Icon: Build,
    accent: '#B0C0D8',
  },
}
